import type { z } from 'zod';
import { CompanyInformationDataSchema } from './companyInformation.schema';
import { AlertBannersSchema } from './alertBanner.schema';

export const GLOBAL_KEYS = {
  COMPANY_INFORMATON: 'company_information',
  ALERT_BANNERS: 'alert_banners',
} as const;

export const GlobalSchemas = {
  [GLOBAL_KEYS.COMPANY_INFORMATON]: CompanyInformationDataSchema,
  [GLOBAL_KEYS.ALERT_BANNERS]: AlertBannersSchema,
} as const;

export type GlobalKey = keyof typeof GlobalSchemas;

export type GlobalTypes = {
  [K in GlobalKey]: z.infer<(typeof GlobalSchemas)[K]>;
};
